import { SibBaseObject } from "../BaseObject/SibBaseObject";

export class Industry extends SibBaseObject{
    name: string;
    code: string;
    description?: string;
   
}